import { Button } from "@/components/ui/button.tsx";
import { AppearanceEditor } from "@/pages/cms/appearance";
import { CmsAdminShell } from "@/pages/cms/advanced/AdminShell";
import { useTranslation } from "react-i18next";

/**
 * Section « Apparence » de l'interface WordPress-like du CMS avancé
 * (`/cms/advanced/apparence`) : RÉUTILISE l'éditeur d'apparence de l'ancien CMS
 * (palette de couleurs, défauts de page, header, footer, boutons) — une seule
 * source de vérité, mêmes réglages qui s'appliquent AUSSI aux pages CMS avancé
 * (palette des ColorRef, thème header/footer, typo par défaut).
 */
export default function CMSAdvancedApparence() {
  const { t } = useTranslation();

  const save = () => {
    const form = document.getElementById("cms-appearance");
    if (form instanceof HTMLFormElement) form.requestSubmit();
  };

  return (
    <CmsAdminShell
      title={t("cms.appearance.title")}
      subtitle={t("cms.appearance.subtitleHint")}
      formIds={["cms-appearance"]}
      actions={<Button onClick={save}>{t("cmsEnregistrerBouton")}</Button>}
    >
      <div className="px-6 py-6">
        <AppearanceEditor />
      </div>
    </CmsAdminShell>
  );
}
